<div class="helpSector">
    <p class="p-title-2 helpSector__title">We're here to help!</p>
    <div class="helpSector__subtitle fm-rubik">
        <p>
            Feel free to reach out using any of the contact methods listed, and we'll get back to you within 24 hours.<br/>
            For general questions, our FAQ page might have just what you're looking for!
        </p>
    </div>
    <div class="helpOptions fm-rubik">
        <div class="helpOption" *ngFor="let option of helpOptions">
            <div class="helpOption__icon">
                <img [src]="option.icon" [alt]="option.label" width="36" height="36">
            </div>
            <div class="helpOption__text">
                <h4 class="helpOption__title">{{ option.label }}</h4>
                <a *ngIf="option.link"
                   [href]="option.link"
                   class="helpOption__cta"
                   target="_blank"
                   rel="noopener noreferrer">
                    {{ option.detail }}
                </a>
                <button
                        *ngIf="option.action"
                        (click)="option.action()"
                        type="button"
                        class="helpOption__cta helpOption__cta--button">
                    {{ option.detail }}
                </button>
            </div>
        </div>
    </div>
</div>
